module.exports = __webpack_public_path__ + "img/180.d34b610c.jpg";